<template>
  <div>
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">评审人</div>
          <div class="field">
            <el-input v-model.trim="expertnums" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">采购人</div>
          <div class="field">
            <el-input v-model.trim="purnums" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button @click="createExpert">评审号生成</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid ref="xGrid" :list="list" tableheight="400" flexname=""
            :cols="cols" :showfooter="false" :showPage="false" :resizable="true"
            :needBlackRow="false" :needPopMenu="false" :canbeEdit="false">
      <template slot="btn">
        <vxe-button  :loading="btnLoading" type='primary' @click="toPrintingview">打印预览</vxe-button>
      </template>
    </vggrid>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'

  export default {
    name: 'pexpertcreateIndex',
    props: {
      projectid: {},
      activeName: {}
    },
    data () {
      return {
        btnLoading: false,
        list: [],
        project:{},
        expertnums: '',
        purnums: '',
        dialogVisible: false,
        dialogType: 0,
        dialogTitle: '',
        cols: [
          {type: 'index', fieldtype: 'I', title: '行号', calculExpr: '',width:80},
          {field: 'pexpertlogincode', fieldtype: 'C', title: '评审号码', calculExpr: ''},
          {field: 'pexpertloginpwd', fieldtype: 'C', title: '评审密码', calculExpr: ''},
          {field: 'pexperttypedesc', fieldtype: 'C', title: '类型', calculExpr: ''},
          {field: 'pexpertroletypedesc', fieldtype: 'C', title: '角色', calculExpr: ''}
        ]
      }
    },
    created () {
    },
    activated(){
      this.init()
      this.getPageList()
    },
    watch: {
      activeName () {
        if(this.activeName === 'zjhcc') {
          this.getPageList()
        }
      }
    },
    components: {vggrid},
    methods: {
      init(){
          this.list = []
      },
      async getprojectInfo(){
        let data = await request({
            url: '/xmgl/project/getProjectById',
            method: "get",
            params: {projectid: this.projectid}
        })
        this.project = data[0]
      },
      async checkRule () {
        let pgList = await request({
          method: "get",
          url: "/xmgl/project/getPgList",
          params: { projectid:  this.projectid },
        });
        if (!pgList.length) {
          this.$message.warning("请设置评审规则!");
          setTimeout(() => {
            this.$router.push({
                name: "projectReviewRuleIndex",
                params: { projectid: this.project.projectid, type: 1 },
             })
          }, 600);
          return false
        } else {
          return true
        }
      },
      async checkScore() {
        this.alertmsg = "";
        let res = await request({
          method: "get",
          url: "/xmgl/pg/getPgList",
          params: { projectid: this.projectid },
        });
        if (res.list.length) {
          let ratioTotal = res.list
            .map((t) => Number(t.pgratio))
            .reduce((a, b) => a + b);
          if (ratioTotal !== 100) {
            if (+this.project.projectpgstotalrule === 1) {
              this.alertmsg =
                '当前项目总分计算方式为"百分比"，评分项目的权重合计必须等于100，请重新设置！';
            } else {
              this.alertmsg =
                '当前项目总分计算方式为"绝对值"，评分项目的分值合计必须等于100分，请重新设置!';
            }
          }

          let scoreTotal = res.list
            .map((t) => Number(t.pgscore))
            .reduce((a, b) => a + b);
          if (+this.project.projectpgstotalrule === 2) {
            if (scoreTotal !== 100) {
              this.alertmsg = `当前项目总分计算方式为"绝对值"，评分项目的分值合计必须等于100分，请重新设置!`;
            }
          } else if (+this.project.projectpgstotalrule === 1) {
            if (scoreTotal !== 300) {
              this.alertmsg = `当前项目总分计算方式为"百分比"，评分项目的各项分值合计必须等于100分，请重新设置!`;
            }
          }
        }
        if (this.alertmsg) {
          this.$message.warning(this.alertmsg);
          return false
        } else {
          return true
        }
      },
      async createExpert () {
        // await this.checkRule()
        await this.getprojectInfo()
        if (!await this.checkRule()) return
        if (!await this.checkScore()) return
        if(this.project.projectstatus >= 30){
          this.$message.warning('项目评审已结束，不可以生成评审人号')
          return
        }
        if ((Number(this.expertnums) + Number(this.purnums)) < 3) {
          this.$message.warning('评审人合计数必须大于等于三人')
          return
        }
        if ((Number(this.expertnums) + Number(this.purnums)) % 2 === 0) {
          this.$message.warning('评审人合计数必须为奇数')
          return
        }
        if (this.list.length) {
          this.$confirm(`已存在评审号，继续生成，将删除已经存在的条目!`, '提示', {
            confirmButtonText: '继续',
            cancelButtonText: '放弃',
            type: 'warning'
          }).then(async() => {
            let data = await request({
              url: '/xmgl/project/pexpertExtract',
              method: "post",
              data: {expertnums: this.expertnums, purnums: this.purnums, projectid: this.projectid}
            })
            if (data.issuccess === 1) {
              await this.getPageList()
              this.$message.success('评审号生成成功')
            } else {
              this.$message.error('评审号生成失败，失败原因：' + data.msg)
            }
          }).catch(() => {
          })
        } else {
          let data = await request({
            url: '/xmgl/project/pexpertExtract',
            method: "post",
            data: {expertnums: this.expertnums, purnums: this.purnums, projectid: this.projectid}
          })
          if (data.issuccess === 1) {
            await this.getPageList()
            this.$message.success('评审号生成成功')
          } else {
            this.$message.error('评审号生成失败，失败原因：' + data.msg)
          }
        }
      },
      vggridClick (code, row) {
        this.$emit(code, row)
      },
      async getPageList () {
        this.loading = true
        this.list = await request({
          url: '/xmgl/project/getPexpertList',
          method: "get",
          params: {projectid: this.projectid}
        })
        let memberCount = 0
        this.list = this.list.map(item => {
          if (+item.pexpertroletype !== 1) {
            memberCount++
            item.pexpertroletypedesc = `组员${memberCount}`
          }
          return item
        })
        this.loading = false
      },
      toPrintingview(){
          // this.$router.push({name: 'printingPreview', params: {list:this.list}})
          //打印 
          let {href} = this.$router.resolve({name: 'printingPreview', query: {projectid:this.projectid}})
          window.open(href, '_blank')
      }
    }
  }
</script>
